import React from 'react'

import { BookingSheetRow } from './components/BookingSheetRow';

import { addDays, createReadableDate, createReturnRoute } from 'services/helpers'

const tableStyles = {
  pageBreakBefore: 'always',
  width: '100%',
  fontSize: 12,
  textAlign: 'center',
  borderCollapse: 'collapse',
};

const columnData = [
  { label: '#' },
  { label: 'Звідки' },
  { label: 'Куди' },
  { label: 'Прізвище' },
  { label: 'Імя' },
  { label: 'Телефон' },
  { label: 'Ціна' },
  { label: 'Відмітка' },
  { label: 'Місце' },
];

export const BookingsSheetBase = ({ bookings, routeName, date, infoForDrivers, returnBookings, variant }) => {
  const readabledate = createReadableDate(date);
  const returnDate = addDays(date, 2);
  const readableReturnDate = createReadableDate(returnDate);
  const returnRoute = createReturnRoute(routeName);

  let displayedDate = readabledate;
  let displayedRoute = routeName;
  let displayedBookings = bookings;

  if (variant === 'return') {
    displayedDate = readableReturnDate;
    displayedRoute = returnRoute;
    displayedBookings = returnBookings
  }

  const printBookings = [...displayedBookings];

  if (printBookings.length < 57) {
    const qty = printBookings.length;

    for (let i = 0; i < 58 - qty; i++) {
      printBookings.push({
        from: '',
        to: '',
        surname: '',
        name: '',
        phone: '',
        price: '',
        note: '',
        routeType: null
      })
    }
  }

  let i = 1;
  const bookingRows = printBookings.map((booking) => (
    <BookingSheetRow key={i} {...booking} i={i++} />
  ));

  return (
    <table style={tableStyles}>
      <caption style={{ textAlign: 'left' }}>
        Дата відправлення: {displayedDate} | Маршрут: {displayedRoute} |
        <span style={{ color: 'red' }}>{infoForDrivers ? ` Інформація: ${infoForDrivers}` : null}</span>
      </caption>
      <thead>
        <tr>
          {columnData.map(({ label }, i) => <th style={i === 0 ? { width: '3%' } : {}} key={label}>{label}</th>)}
        </tr>
      </thead>
      <tbody>
        {bookingRows}
      </tbody>
    </table>
  )
}

BookingsSheetBase.defaultProps = {
  variant: null,
  bookings: [],
  returnBookings: []
}



// WEBPACK FOOTER //
// ./src/components/BookingsSheet/BookingsSheet.js